import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  HStack,
  Img,
  Input,
  Select,
  Stack,
  Text,
  SlideFade,
  useColorModeValue,
  Modal,ModalOverlay,ModalContent,Spinner,
} from "@chakra-ui/react";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { COLORS } from "../../../constants/colors";
import { PROTECTED_PATHS } from "../../../app/constants";
import {
  errorNotifier,
  infoNotifier,
  successNotifier,
} from "../../../components/NotificationHandler";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import { PrimaryButton } from "../../../components/CustomButton";
import { getFamily } from "../services";
import { AuthContext } from "../../../context/authContext";
import Footer from "../../../components/footer";
import { formLabelStyles } from "../../issue report/components/issueReportData";
import ConfirmCardPayment from "./ConfirmCardPayment";
import PaystackModal from "./PaystackModal";
import NinePsbModal from "./NinePsbModal";
import axiosInstance from "../../../services/api";
import { useNavigate } from "react-router-dom";
import { getUserProfile } from "../../settings/service/getUserProfile";

const RequestId = ({ onClose }) => {
  const cardBg = useColorModeValue(COLORS.primary, COLORS.white);
  const [loading, setLoading] = useState(false);
  const [main, setMain] = useState("main");
  const { ID_CARD } = PROTECTED_PATHS;
  const serviceCharge = 5000;
  const transactionFee = 100;
  const { userInfo } = useContext(AuthContext);
  const { userId } = userInfo;
  const [family, setFamily] = useState([]);
  const [media, setMedia] = useState(null);
  const [selectedFamilyName, setSelectedFamilyName] = useState("");
  const [allowToOpen, setAllowToOpen] = useState(false);
  const [userProfile, setUserProfile] = useState(false);  
  const [paymentData, setPaymentData] = useState({});
  const [paymentModal, setPaymentModal] = useState(false);
  const [ninePsbModal, setNinePsbModal] = useState(false);
  const [ninePsbPaymentData, setNinePsbPaymentData] = useState(null);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [payBtnDisabled, setBtnDisabled] = useState(true);
  const [formValues, setformValues] = useState({
    name: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (main === "main") {
      setformValues((prev) => ({ ...prev, [name]: value, familyName: "" }));
    } else {
      setformValues((prev) => ({ ...prev, familyName: value }));
    }
  };

  const sortedFamily = [...family]
    .filter(item => item.status === 'Active')
    .sort((a, b) => {
      if (a.createdAt && b.createdAt) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      }
      return 0;
    });

  useEffect(() => {
    getUserProfile(userId, setLoading, setUserProfile);

    axiosInstance
      .get(`/card/?phoneNumber=${userProfile?.tenantPhone}`)
      .then((res) => {
        setBtnDisabled(false);
      })
      .catch(() => setBtnDisabled(true));
  }, []);

  const navigate = useNavigate();
  useEffect(() => {
    getFamily(userId, setLoading, setFamily);
  }, [userId]);

  useEffect(() => {
    if (main === "main") {
      if (media) {
        setAllowToOpen(true);
        setBtnDisabled(false);
      } else {
        setAllowToOpen(false);
        setBtnDisabled(true);
      }
    } else {
      if (selectedFamilyName && media) {
        setAllowToOpen(true);
        setBtnDisabled(false);
      } else {
        setAllowToOpen(false);
        setBtnDisabled(true);
      }
    }
  }, [
    main,
    family,
    formValues.name,
    formValues.familyName,
    selectedFamilyName,
    media,
  ]);

  const handleImage = (event) => {
    if (!event.target.files) return;

    const file = event.target.files[0];
    const acceptedFormats = ["image/png", "image/jpeg", "image/jpg"];

    if (!acceptedFormats.includes(file.type)) {
      infoNotifier("Please upload a valid image file (PNG, JPEG, JPG)");
      return;
    }

    setMedia(file);
  };

  const inputStyle = {
    bg: "white",
    rounded: "lg",
    color: "#262636",
  };

  const clearMedia = () => {
    setMedia(null);
  };

  return (
    <SlideFade in={true} offsetX="-2000px">
      <>
        {isSubmitting && (
          <Modal isOpen={isSubmitting} onClose={() => {}} isCentered>
            <ModalOverlay />
            <ModalContent
              display="flex"
              justifyContent="center"
              alignItems="center"
              bg="transparent"
              shadow="none"
            >
              <Spinner size="xl" color={COLORS.green} />
              <Text mt={4} color="#fff" fontSize="1.4rem" fontWeight="900">
                Processing... Please wait.
              </Text>
            </ModalContent>
          </Modal>
        )}
      </>
      <Box minH="100vh" pb="15vh">
        <Box shadow="sm">
          <Container>
            <Header goto={ID_CARD} />
          </Container>
        </Box>

        <Container minH="calc(100vh - 100px)">
          <HStack spacing={"20px"}>
            <Text
              color={main === "main" ? "white" : `${cardBg}`}
              fontSize={"20px"}
              bg={main === "main" ? `${COLORS.green}` : "none"}
              p={main === "main" ? "10px 20px" : "0px"}
              rounded={main === "main" ? "3xl" : "0px"}
              onClick={() => {
                setMain("main");
                clearMedia();
              }}
              cursor={"pointer"}
            >
              Main User
            </Text>
            <Text
              color={main === "family" ? "white" : `${cardBg}`}
              fontSize={"20px"}
              bg={main === "family" ? `${COLORS.green}` : "none"}
              p={main === "family" ? "10px 20px" : "0px"}
              rounded={main === "family" ? "3xl" : "0px"}
              onClick={() => {
                setMain("family");
                clearMedia();
              }}
              cursor={"pointer"}
            >
              Family Members
            </Text>
          </HStack>
          <FormControl h="100%" mt="30px">
            <Stack spacing="20px">
              {main === "main" ? (
                <>
                  <Text color={cardBg} fontSize={"20px"}>
                    Upload passport photo and submit to request for a new ID
                    card
                  </Text>
                  <Input
                    {...inputStyle}
                    placeholder="Name"
                    _placeholder={{ opacity: 1, color: "black" }}
                    border="none"
                    borderBottom="1px solid #ccc"
                    borderRadius="0"
                    value={userProfile?.tenantName}
                    readOnly
                  />
                </>
              ) : (
                <>
                  <Text color={cardBg} fontSize={"20px"}>
                    Choose family member to request a new ID card
                  </Text>

                  <Select
                    {...inputStyle}
                    placeholder="Select family"
                    _placeholder={{ opacity: 1, color: "black" }}
                    border="none"
                    color="green"
                    borderBottom="1px solid #ccc"
                    borderRadius="0"
                    onChange={(e) => setSelectedFamilyName(e.target.value)}
                  >
                    {sortedFamily?.map((member, index) => (
                      <option key={index} value={member?.familyName}>
                        {member?.familyName}
                      </option>
                    ))}
                  </Select>
                  <Box>
                    <Text color={cardBg} fontSize={"14px"}>
                      Family name as it will appear on Access card
                    </Text>
                    <Input
                      {...inputStyle}
                      placeholder="Name"
                      name="familyName"
                      _placeholder={{ opacity: 1, color: "black" }}
                      border="none"
                      borderBottom="1px solid #ccc"
                      borderRadius="0"
                      value={selectedFamilyName}
                      readOnly
                    />
                  </Box>
                </>
              )}
            </Stack>

            <Stack>
              <Box mt={"50px"}>
                <FormLabel {...formLabelStyles}>
                  <HStack cursor="pointer">
                    <Text color={cardBg} fontWeight="500">
                      Upload passport photo
                    </Text>
                    <AiOutlineCloudUpload size={"1.5rem"} color={cardBg} />
                  </HStack>
                  <Text color={cardBg} fontSize="13px">
                    Ensure that the photo is clear, taken in a bright place and
                    your face is facing front, and fully visible.
                  </Text>
                  <Input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    display="none"
                    id="media"
                    onChange={handleImage}
                  />
                </FormLabel>
              </Box>
              {media && (
                <Img
                  w="70px"
                  h="70px"
                  m="2"
                  borderRadius={"5px"}
                  src={URL.createObjectURL(media)}
                  alt="Passport"
                />
              )}
            </Stack>
            <HStack py="15px" justify="space-between" gap="1.5rem">
              <Stack
                {...inputStyle}
                textAlign="center"
                bg="#c7ebe2"
                px="15px"
                w="150px"
              >
                <Text as="small">Service Charge</Text>
                <Text fontSize="0.9rem" fontWeight="700" m="0 !important">
                  &#8358;{serviceCharge}
                </Text>
              </Stack>
              <ConfirmCardPayment
                allowToOpen={allowToOpen}
                buttonProps={{
                  size: "md",
                  _hover: { background: `${COLORS.green}` },
                  _focus: { background: `${COLORS.green}` },
                  bg: `${COLORS.green}`,
                  p: "10px",
                  borderRadius: "10px",
                  color: "white",
                  w: "150px",
                  textAlign: "center",
                  btnText: "Pay",
                  isDisabled: payBtnDisabled
                }}
                btnTitle="Pay"
                addCloseModalBtn={true}
              >
                <ConfirmPaymentComponent
                  userProfile={userProfile}
                  userId={userId}
                  paymentLoading={paymentLoading}
                  family={family}
                  setPaymentData={setPaymentData}
                  setPaymentModal={setPaymentModal}
                  setNinePsbPaymentData={setNinePsbPaymentData}
                  setNinePsbModal={setNinePsbModal}
                  setIsSubmitting={setIsSubmitting}
                  media={media}
                  main={main}
                  formValues={formValues}
                  serviceCharge={serviceCharge}
                  transactionFee={transactionFee}
                  navigate={navigate}
                  setLoading={setLoading}
                  selectedFamilyName={selectedFamilyName}
                  onClose={onClose}
                />
              </ConfirmCardPayment>
            </HStack>
            <PaystackModal
              paymentData={paymentData}
              paymentModal={paymentModal}
              setPaymentModal={setPaymentModal}
              onFinish={() => {
                setPaymentModal(false);
                successNotifier("Payment completed successfully!");
                navigate(ID_CARD);
                // Card request is already created, payment is done
              }}
              onClose={() => setPaymentModal(false)}
            />
            <NinePsbModal
              isOpen={ninePsbModal}
              onClose={() => setNinePsbModal(false)}
              paymentData={ninePsbPaymentData}
              redirectPath={ID_CARD}
            />
          </FormControl>
        </Container>
        <Footer />
      </Box>
    </SlideFade>
  );
};

export default RequestId;

// Updated ConfirmPaymentComponent with multiple payment channels
export const ConfirmPaymentComponent = ({
  paymentLoading,
  userId,
  family,
  userProfile,
  setPaymentData,
  setPaymentModal,
  setNinePsbPaymentData,
  setNinePsbModal,
  setIsSubmitting,
  serviceCharge,
  transactionFee,
  media,
  main,
  formValues,
  selectedFamilyName,
  setLoading,
  onClose
}) => {
  const cardBg = useColorModeValue(COLORS.primary, COLORS.white);
  const bgColor = useColorModeValue(COLORS.primary, COLORS.green);
  const [isProcessing, setIsProcessing] = useState(false);
  const paymentChannel = "both"; // "paystack" or "routepay" or "both"

  const buildFormData = (channel) => {
    const familyDetails = main === "family" && family && selectedFamilyName
      ? family.find((data) => data?.familyName === selectedFamilyName)
      : null;

    const formData = new FormData();
    formData.append(
      "name",
      main === "main" ? userProfile?.tenantName : formValues.familyName || selectedFamilyName
    );
    formData.append("designation", userProfile?.designation);
    formData.append(
      "street",
      userProfile?.streetId?.streetName || userProfile?.houseId?.name || ""
    );
    formData.append("passport", media);
    formData.append("paymentType", "card");
    formData.append(
      "houseNumber",
      userProfile?.houseId?.houseNumber
    );
    formData.append("phoneNumber", userProfile?.tenantPhone);
    formData.append("email", userProfile?.email || "");
    formData.append("totalAmount", serviceCharge);
    formData.append("paymentMethod", channel);
    formData.append("channel", channel);

    if (main === "family" && familyDetails) {
      formData.append("parent", familyDetails?.parentId || "");
      formData.append("cardHolder", familyDetails?._id || "");
    }

    return formData;
  };

  const handlePaystackPayment = async () => {
    setIsProcessing(true);
    setLoading(true);

    try {
      const formData = buildFormData("paystack");
      const response = await axiosInstance.post("/card/request", formData);

      if (response?.data?.success || response?.data?.result?.success) {
        const paystackData =
          response?.data?.paystack ||
          response?.data?.result?.paystack ||
          response?.data?.result?.data?.paystack;
        if (paystackData && paystackData?.authorization_url) {
          setPaymentData(paystackData);
          onClose();
          setPaymentModal(true);
          successNotifier("Card request submitted! Please complete payment.");
        } else {
          throw new Error("Payment authorization URL not found in response");
        }
      } else {
        throw new Error(response?.data?.message || "Failed to create card request");
      }
    } catch (error) {
      console.error("Card request error:", error);
      errorNotifier(
        error?.response?.data?.message ||
        error?.response?.data?.result?.message ||
        error.message ||
        "An error occurred while creating the card request."
      );
    } finally {
      setIsProcessing(false);
      setLoading(false);
    }
  };

  const handleNinePsbPayment = async () => {
    setIsProcessing(true);
    setLoading(true);

    try {
      const formData = buildFormData("9psb");
      const response = await axiosInstance.post("/card/request-9psb", formData);

      const paymentInfo = response?.data;
      const tnxRef =
        paymentInfo?.data?.transactionReference ||
        paymentInfo?.result?.data?.transactionReference;
      if (tnxRef) {
        localStorage.setItem("Card-tnx", tnxRef);
      }

      // Extract payment data from response (supports both data and result formats)
      const accountData = paymentInfo?.data || paymentInfo?.result;
      
      if (accountData && accountData?.data) {
        // Show modal with payment information instead of redirecting
        setNinePsbPaymentData(accountData);
        onClose();
        setNinePsbModal(true);
        successNotifier("Virtual account created! Please review the details.");
      } else {
        throw new Error("Virtual account details not found in response.");
      }
    } catch (error) {
      console.error("9PSB card request error:", error);
      errorNotifier(
        error?.response?.data?.message ||
        error?.response?.data?.result?.message ||
        error.message ||
        "Payment failed. Please try again."
      );
    } finally {
      setIsProcessing(false);
      setLoading(false);
    }
  };

  return (
    <Box color={cardBg}>
      <Text fontWeight="bold" mb="2" fontSize={"1.3em"}>
        Choose Payment Method
      </Text>
      <Text mb="4">
        Kindly select your preferred payment method. You'll receive an
        acknowledgement via Email/SMS.
      </Text>

      {paymentChannel === "paystack" ? (
        <PrimaryButton
          w="100%"
          size="md"
          isLoading={isProcessing}
          btnText="Pay with Paystack"
          onClick={handlePaystackPayment}
        />
      ) : paymentChannel === "9psb" ? (
        <Button
          w="100%"
          mt="10px"
          bg="#87B61C"
          color={COLORS.white}
          _hover={{ opacity: 0.85, background: "#28724F" }}
          isLoading={isProcessing}
          onClick={handleNinePsbPayment}
        >
          {isProcessing ? "Processing..." : "Pay with 9PSB (Transfer)"}
        </Button>
      ) : (
        <Stack spacing={4}>
          <Text fontSize="sm" fontWeight="bold">
            Note: Use Paystack to pay with card, or 9PSB to pay with transfer.
          </Text>
          <Button
            w="100%"
            bg="#87B61C"
            color={COLORS.white}
            _hover={{ opacity: 0.85, background: "#28724F" }}
            isLoading={isProcessing}
            onClick={handleNinePsbPayment}
          >
            {isProcessing ? "Processing..." : "Pay with 9PSB (Transfer)"}
          </Button>
          <PrimaryButton
            w="100%"
            size="md"
            isLoading={isProcessing}
            btnText="Pay with Paystack"
            onClick={handlePaystackPayment}
          />
        </Stack>
      )}
    </Box>
  );
};